<template>
  <div class="Sys-warp" te>
    <el-breadcrumb class="bread_crumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>企业业务查询</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="title">企业业务查询</div>
    <el-divider/>
    <div style="width: 100%;display: flex;justify-content: center">
      <div class="form-container" v-if="!listMode">
        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="77px" label-position="left"
                 style="width: 50%">

          <el-form-item label="手机号" prop="phone">
            <el-input v-model="formData.phone" placeholder="输入联系人手机号"
                      oninput="if(value.length>11)value=value.slice(0,11)"
                      style="width: 100%" type="number"/>
          </el-form-item>
          <!--          <el-form-item label="审批号" prop="no">-->
          <!--            <el-input v-model="formData.no" placeholder="输入审批号" oninput="if(value.length>10)value=value.slice(0,10)"-->
          <!--                      style="width: 100%" type="number"/>-->
          <!--          </el-form-item>-->
          <el-form-item label="验证码" prop="verifyCode">
            <el-input v-model="formData.verifyCode" placeholder="请输入验证码"
                      oninput="if(value.length>4)value=value.slice(0,4)"
                      style="width: 100%" type="number">
              <template slot="append">
                <div class="send-verify-code-btn" @click="sendVerifyCode"> {{
                    isSendVerifyCode ? count + '秒' : '发送验证码'
                  }}
                </div>
              </template>
            </el-input>
          </el-form-item>
          <!--          <el-form-item label="查询类型" prop="businessType">-->
          <!--            <el-radio-group v-model="formData.businessType">-->
          <!--              <el-radio :label="1">入驻审批</el-radio>-->
          <!--              <el-radio :label="2">工商变更</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
          <!--          <p style="color: #7d7d7d;font-size: 14px;width: 100%;text-align: center">请输入申请时留下的联系人手机号和审批号查询审批进度</p>-->
          <p style="color: #7d7d7d;font-size: 14px;width: 100%;text-align: center">请输入办理业务时留下的联系人手机号</p>
          <el-button type="primary" @click="query()" style="width: 100%;margin-top: 20px">查询</el-button>
        </el-form>
      </div>

      <div v-if="listMode" style="width: 100%;">


        <el-tabs v-model="current" @tab-click="handleClick">
          <el-tab-pane label="进行中业务" name="0"></el-tab-pane>
          <el-tab-pane label="被驳回业务" name="1"></el-tab-pane>
          <el-tab-pane label="已通过业务" name="2"></el-tab-pane>
        </el-tabs>

        <el-table
            :data="dataList"
            border
            v-loading="dataListLoading"
            style="width: 100%;">
          <el-table-column
              width="135px"
              header-align="center"
              align="center"
              label="业务类型">
            <template slot-scope="scope">
              <div v-if="scope.row.businessType!=null">
                {{ getAuditTypeStr(scope.row) }}
              </div>
              <div v-else>
                <el-tooltip class="item" effect="dark" content="完成工商注册或变更后，请及时上传新营业执照"
                            placement="top-start">
                  <div><i style="color: #dd0000;margin-right: 5px"
                          class="el-icon-warning"/>{{ getAuditTypeStr(scope.row) }}
                  </div>
                </el-tooltip>
              </div>

            </template>
          </el-table-column>
          <!--      <el-table-column-->
          <!--        width="100px"-->
          <!--        header-align="center"-->
          <!--        align="center"-->
          <!--        label="审批编号">-->
          <!--        <template slot-scope="scope">-->
          <!--          {{scope.row.no}}{{scope.row.applyNo}}-->
          <!--        </template>-->
          <!--      </el-table-column>-->
          <el-table-column
              prop="applyName"
              header-align="center"
              align="center"
              label="主体名称">
            <template slot-scope="scope">
              <div v-if="scope.row.businessType!=null">
                {{ scope.row.applyName }}
              </div>
              <div v-else>
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="prjBaseInfoName"
              header-align="center"
              align="center"
              label="入驻载体">
          </el-table-column>
          <el-table-column
              prop="operatorName"
              header-align="center"
              align="center"
              label="载体运营方">
          </el-table-column>
          <el-table-column
              prop="createDate"
              width="100"
              header-align="center"
              align="center"
              label="申请日期">
            <template slot-scope="scope">
              {{ scope.row.createDate.substring(0, 11) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="isEnabled"
              header-align="center"
              width="100px"
              align="center"
              label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.businessType!=null">
                <el-tag class="statusTag" v-if="scope.row.status === 4" size="small" type="danger">{{
                    scope.row.statusName
                  }}
                </el-tag>
                <el-tag class="statusTag" v-else-if="scope.row.status === 3" size="small" type="success">{{
                    scope.row.statusName
                  }}
                </el-tag>
                <el-tag class="statusTag" v-else size="small">{{ scope.row.statusName }}</el-tag>
              </div>
              <div v-if="scope.row.businessType==null">
                <el-tag class="statusTag" type="danger" size="small">需尽快处理</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              header-align="center"
              align="center"
              width="100"
              label="操作">
            <template slot-scope="scope">
              <div style="display: flex;flex-direction: column;justify-content: center">
                <el-button type="text" v-if="scope.row.businessType!=null" size="small"
                           @click="detailHandle(scope.row.id)">查看
                </el-button>
                <el-button type="text" v-if="scope.row.businessType==null" size="small"
                           @click="uploadCompanyLicenseHandle(scope.row)">上传营业执照
                </el-button>
                <el-button type="text" style="margin-left: 0px" v-if="judgeShowDownloadFile(scope.row)" size="small"
                           @click="downloadFile(scope.row.id)">下载审批文件
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>

  </div>
</template>

<script>

import {
  smsCodeSend,
  checkSmsCode,
  getInApplyListByContactPhone,
  queryEnterPriseListByContactPhone, getApplyInfo
} from "@/api/api";
import {checkMobile, encrypt} from "@/utils/util";
import constant from "@/utils/constant";

var validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话号码'))
  } else if (!checkMobile(value)) {
    callback(new Error('请输入正确的11位手机号码'))
  } else {
    callback()
  }
}

export default {
  name: 'Query',
  data() {
    return {
      current: 0,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      listMode: false,
      isSendVerifyCode: false,
      timer: null,
      count: 60,
      formData: {
        no: '',
        phone: '',
        verifyCode: '',
        businessType: constant.BUSINESS_TYPE_IN
      },
      rules: {
        no: [
          {required: true, message: '请输入审批号', trigger: 'change'},
        ],
        phone: [
          {required: true, validator: validPhone, trigger: 'change'},
        ],
        verifyCode: [
          {required: true, message: '请输入验证码', trigger: 'change'},
        ],
        businessType: [
          {required: true, message: '请选择查询类型', trigger: 'change'},
        ],
      }

    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {

    },
    sendVerifyCode() {
      if (this.isSendVerifyCode == true) {
        return;
      }
      if (!checkMobile(this.formData.phone)) {
        this.$message.error("请先输入手机号码")
        return
      }
      let _this = this
      _this.isSendVerifyCode = true;
      smsCodeSend(this.formData.phone).then(res => {
        if (res.code == 0) {
          _this.$message.success('验证码已发送')
          const TIME_COUNT = 60;
          if (!_this.timer) {
            _this.count = TIME_COUNT;
            _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                _this.count--;
              } else {
                _this.isSendVerifyCode = false;
                clearInterval(this.timer);
                _this.timer = null;
              }
            }, 1000)
          }
        } else {
          _this.isSendVerifyCode = false;
          this.$message({
            message: '发送验证码失败:' + res.msg,
            type: 'error',
            offset: 300
          })
        }
      })
    },
    query() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const timestamp = Date.now();
          checkSmsCode(this.formData.phone, this.formData.verifyCode, timestamp).then(res => {
            if (res.code == 0) {
              this.doubleCheck(res.verifyCode, this.formData.phone, this.formData.verifyCode, timestamp)
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                offset: 300
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    doubleCheck(verifyStr, phone, verifyCode, timestamp) {
      let localVerifyStr = encrypt(phone, verifyCode, timestamp)
      if (localVerifyStr === verifyStr) {
        this.getDataList()
      } else {
        this.$message({
          message: '本地加密校验失败，请联系管理员',
          type: 'error',
          offset: 300
        })
      }
    },
    getAuditTypeStr(item) {
      if (item.businessType != null) {
        if (item.businessType == constant.BUSINESS_TYPE_CHANGE) {
          return '工商变更'
        }
        if (item.businessType == constant.BUSINESS_TYPE_IN) {
          return '入驻申请'
        }
        if (item.businessType == constant.BUSINESS_TYPE_COMPANY_LICENSE) {
          return '营业执照审批'
        }
        if (item.businessType == constant.BUSINESS_TYPE_PROOF_OF_USE) {
          return '房屋使用证明申请'
        }
      } else {
        return '补传营业执照'
      }
    },
    handleClick() {
      this.getDataList()
    },
    judgeShowDownloadFile(item) {
      if (item.status == 3 && item.businessType != constant.BUSINESS_TYPE_COMPANY_LICENSE) {
        return true
      }
      return false
    },
    // 获取数据列表
    getDataList() {
      this.listMode = true
      this.dataListLoading = true
      let status;
      if (this.current == 0) {
        status = 2
      } else if (this.current == 1) {
        status = 4
      } else if (this.current == 2) {
        status = 3
      }
      getInApplyListByContactPhone(this.formData.phone, this.formData.verifyCode, status).then(data => {
        let applyList
        if (data && data.code === 0) {
          applyList = data.data.list
          if (this.current == 0) {
            queryEnterPriseListByContactPhone(this.formData.phone, this.formData.verifyCode).then(data => {
              let enterpriseList
              if (data && data.code === 0) {
                enterpriseList = data.data.list
              } else {
                enterpriseList = []
              }
              this.dataList = enterpriseList.concat(applyList);
            })
          } else {
            this.dataList = applyList
          }


        } else {
          this.dataList = []
          this.totalPage = 0
          this.$message({
            message: data.msg,
            type: 'error',
            offset: 300
          })
        }
        this.dataListLoading = false

      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 查看
    detailHandle(id) {
      let applyId = id
      let routeUrl = this.$router.resolve({
        name: 'InApplyDetail',
        params: {
          id: applyId
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    uploadCompanyLicenseHandle(enterprise) {
      let routeUrl = this.$router.resolve({
        name: 'CompanyLicenseUploadApply',
        params: {
          enterpriseId: enterprise.id
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    downloadFile(id) {
      getApplyInfo(id).then(res => {
        if (res.code == 0) {
          let data = res.data.prjInApply;
          let applyFile = null;

          for (var i = 0; i < data.attachmentList.length; i++) {
            let attachment = data.attachmentList[i]
            let value = {
              "name": attachment.ossFileName,
              "url": attachment.url
            }
            if (attachment.type == constant.CONST_APPLY_SUCCESS_FILE_TYPE) {
              applyFile = value;
              let url = applyFile.url;
              window.open(url)
              return;
            }
          }
        } else {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.jumpToHome()
            }
          });
        }
      })

    }
  },
}
</script>
<style scoped>
.form-container {
  margin-top: 50px;
  border-radius: 15px;
  border: 1px solid rgba(206, 206, 206, 1);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 13px 17px 0px rgba(0, 0, 0, 0.1);
  width: 800px;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type=‘number’] {
  -moz-appearance: textfield !important;
}

.send-verify-code-btn {
  cursor: pointer;
}
</style>
